<div class="notification-title display-flex align-items-center no-wrap" mat-dialog-title>
  {{ 'Custom ' + title }}
</div>

<mat-dialog-content>
  <div class="notification-modal">
    <div class="display-flex flex-column grid-gap-16">
      <div class="flex-1">
        <div class="display-flex grid-gap-16 align-items-end">
          <!-- notifyOn / remindOn -->
          <ng-container *ngIf="data.fieldType === 'notifyOn' || data.fieldType === 'remindOn'">
            <div class="flex-50 remind-field">
              <app-input
                [labelCss]="'nowrap pre-label'"
                [containerCss]="'display-flex flex-column grid-gap-4'"
                [markAsInvalid]="formSubmitted && daysControl.invalid"
                attrPlaceholder="Enter number of days"
                [formControl]="daysControl"
                [attrLabel]="title"></app-input>
            </div>
            <div class="flex-50 remind-field">
              <app-radio-button-dropdown
                class="flex-grow-1"
                [containerCss]="'w-100'"
                [items]="beforeAfterItems"
                [formControl]="beforeAfterControl"
                [allowClear]="false"
                [allowSearch]="false"
                [autoSortList]="false"
                [showValidationError]="false"
                [labelRequired]="false"
                attrAppendTo="body"></app-radio-button-dropdown>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="display-flex justify-content-space-between w-100">
    <button mat-stroked-button color="primary" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()">Done</button>
  </div>
</mat-dialog-actions>
